module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_arrow_next.5f991.png";